import { gql } from '@apollo/client';
import IncomingOrdersDetailFragment from "../../fragments/IncomingOrders/incomingOrdersFragment";

const getIncomingOrder = gql`
  query GetIncomingOrder($supplierOrderId: Int!) {
    incomingOrdersContext {
      details(supplierOrderId: $supplierOrderId) {
        ...IncomingOrdersDetailFragment
      }
    }
  }

  ${IncomingOrdersDetailFragment}  
`;

export default getIncomingOrder;
